import { graphql } from "gql";

const RELATED_MESSAGE_THREADS_QUERY = graphql(`
  query RelatedMessageThreads($id: [ID!]!) {
    messageThreads(id: $id) {
      ...MessageThread
      relatedMessageThreadList {
        ...RelatedMessageThread
      }
    }
  }
`);

export default RELATED_MESSAGE_THREADS_QUERY;
